<template>
  <LinkCard
    :icon="['fal', 'puzzle-piece']"
    :image="thumbnail"
    :title="$path('internalName', value)"
    :badges="badges"
    :to="$attrs.to || { name: 'residential-template-edit', params: { id: value.id } }"
  />
</template>

<script>
import LinkCard from '@/components/LinkCard'
import StatusIndicator from '@/components/StatusIndicator'

export default {
  props: {
    value: Object,
  },
  computed: {
    thumbnail() {
      let item = (this.$path('value.media.cover') || []).find(({ type }) => type.startsWith('image'))
      if (!item) return

      return { src: item.url, alt: this.value.name }
    },
    badges() {
      if (this.value.demo) return [{ theme: 'warning', value: this.$t('demo') }]
      return []
    },
  },
  components: {
    LinkCard,
    StatusIndicator,
  },
}
</script>
